import React, { createContext, useState, useEffect } from 'react';
import { getData } from '../config/api-connect';

export const LeaveContext = createContext({
  pendingLeaveCount: 0,
  refreshPendingLeaves: () => {},
});

export function LeaveProvider({ children }) {
  const [pendingLeaveCount, setPendingLeaveCount] = useState(0);

  const fetchPendingLeaves = async () => {
    try {
      const response = await getData('/buddy/get_pending_team_leaves/');
      setPendingLeaveCount(response.count || 0);
    } catch (e) {
      console.error('failed to fetch pending leaves', e);
    }
  };

  useEffect(() => {
    fetchPendingLeaves();
  }, []);

  return (
    <LeaveContext.Provider value={{ pendingLeaveCount, refreshPendingLeaves: fetchPendingLeaves }}>
      {children}
    </LeaveContext.Provider>
  );
}

export default LeaveProvider;
